(function () {
  var WISHLIST_KEY = 'amirio:wishlist';

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.amirio-sizes__size');
      if (!button || button.disabled) return;

      var form = button.closest('.amirio-sizes');
      var input = form && form.querySelector('input[ref="variantId"]');
      if (input) input.value = button.dataset.variantId;
    },
    true
  );

  function readWishlist() {
    try {
      var stored = JSON.parse(localStorage.getItem(WISHLIST_KEY));
      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(handles) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
    } catch (error) {
    }
  }

  function paint(root) {
    var saved = readWishlist();
    (root || document).querySelectorAll('[data-amirio-wishlist]').forEach(function (button) {
      button.setAttribute('aria-pressed', saved.indexOf(button.dataset.handle) > -1 ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-amirio-wishlist]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = button.dataset.handle;
    var saved = readWishlist();
    var index = saved.indexOf(handle);

    if (index > -1) saved.splice(index, 1);
    else saved.push(handle);

    writeWishlist(saved);
    paint();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paint();
    });
  } else {
    paint();
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      paint();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
